import {
  DeleteOutlined,
  EditOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Row,
  Space,
  Spin,
  Table,
  Tag,
} from "antd";
import React from "react";
import AddInventoryMaster from "./AddInventoryMaster";
import { useTheme } from "../../../Context/ThemeContext";
import { ColumnsType } from "antd/es/table";
import InventoryMasterService from "../../../Services/Inventory/InventoryMasterService";
import Search from "antd/es/input/Search";
import { useClient } from "../../../Context/ClientContext";

export const documentType = [
  "GST Certificate",
  "GST Certificate",
  "PAN",
  "TAN",
  "CIN",
  "Udhyam",
  "Udyam Registration Certificate",
  "Import Export Certificate",
  "ISO Quality Certificate",
  "ISI Certificate",
  "Audited Balance Sheet",
  "Memorandum Of Association",
  "Incorporation Certificate",
  "Factory Registration Certificate",
  "Bank Solvency Form",
  "Bank Detail With Cancel Cheque",
  "PlantMachineryList",
  "Testing Equipments List With Calibration Status",
  "Clientage Detail",
  "Turnover Details",
  "Previous Supplies Detail",
  "List Of Directors Partners",
  "Product Details",
];

const InventoryMaster = () => {
  const { themeData } = useTheme();
  const { currentClient } = useClient();
  const [openModal, setOpenModal] = React.useState<boolean>(false);
  const [masterData, setMasterData] = React.useState<any[]>();
  const [search, setSearch] = React.useState<string>("");
  const [loading, setLoading] = React.useState<boolean>(false);
  const [id, setId] = React.useState<string | undefined>();
  const [showInList, setShowInList] = React.useState<boolean>(false);
  const [refresh, setRefresh] = React.useState<boolean>(false);
  React.useEffect(() => {
    getMasterDetails();
  }, [search, refresh]);

  const getMasterDetails = async () => {
    setLoading(true);
    let res = await InventoryMasterService?.getMasterDetails(
      currentClient?.id,
      search,
      "",
      "",
      showInList
    );

    if (res?.result) {
      setMasterData(
        res?.result?.map((d: any, index: number) => {
          return {
            sNo: index + 1,
            id: d?.id,
            name: d?.name,
            docType: d?.docType,
            showInList:
              d?.showInList === true ? (
                <Tag color="green">Active</Tag>
              ) : (
                <Tag color="orange">In-Active</Tag>
              ),
            // field: d?.field,
          };
        })
      );
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  console.log("data", masterData);

  const columns: ColumnsType<any> = [
    {
      title: "S. No.",
      dataIndex: "sNo",
    },
    {
      title: "Document Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Document Type",
      dataIndex: "docType",
      key: "docType",
      render: (_: any, record: any) => <>{documentType[record?.docType]}</>,
    },
    {
      title: "Status",
      dataIndex: "showInList",
      key: "showInList",
    },

    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
      render: (_: any, record: any) => (
        <>
          <Space>
            <Button
              style={{ padding: "1px 5px" }}
              onClick={() => {
                setId(record?.id);
                setOpenModal(true);
              }}
              size="small"
            >
              <EditOutlined />
            </Button>
            <Button
              size="small"
              icon={<DeleteOutlined />}
              style={{ color: "red" }}
            />
          </Space>
        </>
      ),
    },
  ];

  return (
    <>
      <Card
        size="small"
        className="TableCard"
        style={{
          marginTop: 10,
          boxShadow: "0px 0px 10px 0px #96A1C84D",
        }}
      >
        <Spin spinning={loading} indicator={<LoadingOutlined />}>
          <Row style={{ marginTop: "10px" }} justify={"space-between"}>
            <Col span={12}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setId("");
                  setOpenModal(true);
                }}
              >
                Master
              </Button>
            </Col>

            <Col span={12}>
              <Row gutter={15} justify={"end"}>
                <span style={{ paddingTop: "3px" }}>Search : </span>
                <Col>
                  <Search
                    placeholder="Search here"
                    onChange={(e: any) => setSearch(e.target.value)}
                  />
                </Col>
                {/* <span style={{ paddingTop: "3px" }}>Status : </span>
                <Col>
                  <Select
                    defaultValue={status}
                    style={{ width: "200px" }}
                    options={[
                      { value: LedgerStatus.active, label: "Active" },
                      { value: LedgerStatus.all, label: "All" },
                      { value: LedgerStatus.deactive, label: "De-Active" },
                      { value: LedgerStatus.deleted, label: "deleted" },
                    ]}
                    onChange={(val: any) => setStatus(val)}
                  />
                </Col> */}
              </Row>
            </Col>
          </Row>
          <div style={{ marginTop: "10px" }}>
            <Table
              columns={columns}
              dataSource={masterData}
              className={`Tabel-style table-${
                themeData?.componentSize ?? "middle"
              }`}
            />
          </div>
        </Spin>
      </Card>

      {openModal && (
        <AddInventoryMaster
          onCancel={() => setOpenModal(false)}
          openModal={openModal}
          id={id}
          setRefresh={setRefresh}
        />
      )}
    </>
  );
};

export default InventoryMaster;
